import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'Search',
  setup: function setup() {
    var itemRef = ref();
    var groupRef = ref();
    return {
      itemRef: itemRef,
      groupRef: groupRef,
      itemList: [{
        value: 1,
        label: 'python'
      }, {
        value: 2,
        label: 'scratch'
      }, {
        value: 3,
        label: 'c++'
      }],
      groupList: [{
        value: 1,
        label: '小低组'
      }, {
        value: 2,
        label: '小高组'
      }, {
        value: 3,
        label: '初中组'
      }]
    };
  }
});